<script setup lang="ts">
import splash from "@brand-splash"
import { ref } from "vue"
import { useTranslation } from "@/composables"

const { t } = useTranslation()
const imageLoaded = ref(false)

function handleImageLoad() {
  imageLoaded.value = true
}
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-white z-9999">
    <div class="flex flex-col items-center gap-4">
      <img
        v-show="imageLoaded"
        :src="splash"
        :alt="t('loading_alt')"
        class="h-24 w-24 rounded-full animate-pulse"
        @load="handleImageLoad"
      >
      <p class="text-gray-600 font-medium">
        {{ t("loading_dot") }}
      </p>
    </div>
  </div>
</template>
